import React from "react";
import Aboutus from "../../assets/images/about.png";
import About2 from "../../assets/images/business-man.png";
import AboutImage from "../../assets/about/about1.jpg";
import "animate.css";
import { Link } from "react-router-dom";
import BgImg from "../../assets/portfolio/bg2.png";
import { Helmet } from "react-helmet-async";
function AboutUs() {
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>About Us - Deetyasoft | IVR, Web & App Development India</title>
        <meta
          name="description"
          content="Deetyasoft offers IVR, web, and mobile app solutions for real estate, telecom, healthcare, and more—trusted IT partner for business growth."
        />
        <meta
          name="keywords"
          content="IVR Solutions, Custom IVR Development, IT Solutions Provider India, Web & App Development Company, Mobile App Development Services, Website Design Services India Real Estate IVR Solutions, Telecom IVR Systems, Healthcare IVR Software, IVR for Schools & Hospitals, 24x7 Customer Support IVR, Real-Time IVR Analytics Enterprise IVR System, Scalable IVR Platform, Best IVR solution provider for businesses in India, Mobile app and website design company India"
        />
        <link rel="canonical" href="https://deetyasoft.com/about-us" />

        {/* Facebook Meta Tags */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/about-us" />
        <meta
          property="og:title"
          content="About Us - Deetyasoft | IVR, Web & App Development India"
        />
        <meta
          property="og:description"
          content="Deetyasoft offers IVR, web, and mobile app solutions for real estate, telecom, healthcare, and more—trusted IT partner for business growth."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/about.a80ec823d907592ae2ad.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://deetyasoft.com/about-us" />
        <meta
          name="twitter:title"
          content="About Us - Deetyasoft | IVR, Web & App Development India"
        />
        <meta
          name="twitter:description"
          content="Deetyasoft offers IVR, web, and mobile app solutions for real estate, telecom, healthcare, and more—trusted IT partner for business growth."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/about.a80ec823d907592ae2ad.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        {/* Other Meta Tags */}
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta httpEquiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* JSON-LD Structured Data Scripts */}
        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Deetya Soft Pvt Ltd",
          "description": "Deetyasoft offers IVR, web, and mobile app solutions for real estate, telecom, healthcare, and more—trusted IT partner for business growth.",
          "image": "https://deetyasoft.com/static/media/about.a80ec823d907592ae2ad.png",
          "logo": "https://www.deetyasoft.com/images/logo.png",
          "url": "https://www.deetyasoft.com",
          "telephone": ["+91-9015350505", "+91-9717055088"],
          "email": "info@deetyasoft.com",
          "sameAs": [
            "https://www.linkedin.com/company/deetya-soft-private-limited",
            "https://www.facebook.com/deetyasoftprivatelimited",
            "https://www.instagram.com/deetyasoft",
            "https://www.youtube.com/@deetyasoft",
            "https://www.crunchbase.com/organization/deetyasoft"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
            "addressLocality": "Ghaziabad",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201014",
            "addressCountry": "IN"
          }
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "url": "https://www.deetyasoft.com",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-981-862-7588",
              "contactType": "technical support",
              "areaServed": "IN"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+91-901-535-0505",
              "contactType": "sales",
              "areaServed": "IN"
            }
          ]
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Parshan "
          },
          "reviewBody": "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
          "url": "https://www.deetyasoft.com/",
          "description": "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
          "datePublished": "2025-06-17",
          "name": "Deetya Soft Pvt Ltd",
          "reviewRating": {
            "@type": "Rating",
            "worstRating": "1",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "itemReviewed": {
            "@type": "Organization",
            "name": "Deetya Soft Pvt Ltd"
          }
        }`}
        </script>
      </Helmet>

      <div className="relative w-full h-[60vh] md:h-[70vh] bg-black">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src={AboutImage}
            alt="About3"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 md:px-16 text-white">
          <h1 className="text-3xl md:text-5xl font-semibold mb-4">About Us</h1>
          <div className="flex items-center space-x-2 text-sm md:text-base">
            <Link to="/" className="text-white hover:text-main1 font-semibold">
              Home
            </Link>
            <span className="text-red-500">●</span>
            <span className="text-gray-300 hover:text-main1">About Us</span>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 py-16 px-4 sm:px-6 lg:px-8">
        {/* <div className="container mx-auto px-4  text-center">
          <h3 className="md:text-4xl text-2xl  mb-2 font-semibold">About Us</h3>
          <div className=" md:w-24 w-20   h-1 bg-main mx-auto mb-5 rounded-full" />
        </div> */}

        {/* Section 1: Image on left, text on right */}
        <div className="">
          <div className="about-section animate__animated animate__fadeInUp animate__delay-1s">
            <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="w-full px-4 md:px-8 lg:px-16 md:order-1 order-2 py-6">
                <img
                  src={Aboutus} // Your image import or path
                  alt="About Us"
                  className="w-full h-auto max-w-5xl mx-auto object-cover"
                />
              </div>

              <div className=" md:order-2 order-1">
                <h2 className="md:text-3xl text-2xl font-semibold text-gray-500 mb-4">
                  About
                  <span className=" pl-1 text-main1">Us</span>
                </h2>
                <p className="text-gray-700 md:text-base text-sm text-justify leading-relaxed">
                  Deetya Soft is an IT solution provider for varied services in
                  application development, website designing, mobile application
                  development campaigning solutions and SU solutions.
                  <br /> Our team of experts works closely with the clients to
                  create customised IVR solution tailored to specific industry
                  requirements. Our next generation IVR Solution suitable to all
                  business sectors from small business to large enterprises i.e
                  real estate, Telecom, schools, hospitals, healthcare,
                  commercial product organizations and management firms. Our
                  flexible IVR solution scales with the growth of business,
                  provide 24*7 support, real-time analytics that enhance
                  ultimate customer satisfaction.
                </p>
                {/* <h4 className="  font-semibold text-main1">Parshan Kumar</h4>
                <h5 className=" text-main1 font-semibold">CEO AND FOUNDER</h5> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Section 2: Image on right, text on left */}

      <div>
        <div className="container mx-auto px-4 pt-10  text-center">
          <h3 className="md:text-4xl text-2xl mb-2 font-semibold">
            Our Mission
          </h3>
          <div className=" md:w-24 w-20   h-1 bg-main mx-auto rounded-full" />
        </div>
        <div className="about-section animate__animated animate__fadeInUp animate__delay-1s py-12 px-4 md:px-8 lg:px-16">
          <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            {/* Text Content Section */}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mb-4">
                Our Mission
              </h2>
              <p className="text-gray-700 text-justify leading-relaxed text-sm md:text-base mb-6">
                <strong>At Deetya Soft </strong> Our mission is to provide all
                types of businesses with user-friendly IVR solutions that
                enhance customer engagement, optimize call centre operations,
                and improve response time, ensuring a better customer experience
                at scale. We are committed to transforming customer experience
                with next generation IVR technology that enable businesses to
                make data-driven decisions and continuously improve customer
                experiences.
              </p>
            </div>

            {/* Image Section */}
            <div>
              <img
                src={About2} // Replace with actual image path or import
                alt="About Us"
                className="w-full h-auto max-w-full  object-cover transform  ease-in-out"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Image on left, text on right */}
      <div
        className="relative py-12 px-4 md:px-8 lg:px-16"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "50vh",
        }}
      >
        <div className="text-center">
          {/* Main Heading */}
          <h2 className="md:text-4xl text-2xl font-bold">
            <span className="text-black">Our </span>
            <span className="text-sky-500">Values</span>
          </h2>

          {/* Decorative Underline */}
          <div className="relative w-fit mx-auto mb-4">
            <div className="h-[1px] bg-gray-300 w-[150px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>
        </div>
        {/* Content Card */}
        <div className="">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10 ">
            {/* Image Section */}
            <div>
              <img
                src={AboutImage} // Use actual path or import
                alt="Our Values"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>

            {/* Text Section */}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-4">
                Our Values
              </h2>
              <p className="text-gray-700 text-justify leading-relaxed text-sm md:text-base">
                We, at Deetya soft are committed to continuous innovation in
                improving and developing our product and services. Our core
                value focuses on customer satisfaction, we design our product
                that meets the unique needs of each client. We are committed to
                operate our business with great transparency and honesty, we
                maintain high ethical standards, promise to build trust with our
                clients. We work closely with our clients to understand their
                requirements, helps to built strong relationship with them. We
                believe to work for excellence in everything we do.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
